export default "__VITE_ASSET__BrUR6w5x__"